import { Link } from 'react-router-dom';

interface ArticleCardProps {
  slug: string;
  title: string;
  category: string;
  categoryName: string;
  coverImage: string;
  excerpt: string;
  publishDate: string;
  viewCount: number;
  commentCount: number;
  tag?: string;
  rank?: number;
}

export default function ArticleCard({
  slug,
  title,
  category,
  categoryName,
  coverImage,
  excerpt,
  publishDate,
  viewCount,
  commentCount,
  tag,
  rank,
}: ArticleCardProps) {
  return (
    <article className="bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all duration-300 group cursor-pointer overflow-hidden">
      <Link to={`/article/${slug}`} className="block">
        <div className="flex flex-col sm:flex-row">
          <div className="relative w-full sm:w-56 h-48 sm:h-auto shrink-0 overflow-hidden">
            <img
              src={coverImage}
              alt={title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            {rank && (
              <div className="absolute top-3 left-3 w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-bold text-sm">
                {rank}
              </div>
            )}
            {tag && (
              <div className="absolute top-3 right-3 px-2 py-0.5 bg-accent-500 text-background-50 rounded text-xs font-medium">
                {tag}
              </div>
            )}
          </div>
          <div className="flex-1 p-4 md:p-5 flex flex-col justify-between min-w-0">
            <div>
              <div className="flex items-center gap-3 mb-2 flex-wrap">
                <Link
                  to={`/category/${category}`}
                  className="text-xs text-primary-600 bg-primary-100 px-2.5 py-0.5 rounded-full font-medium hover:bg-primary-200 transition-colors cursor-pointer whitespace-nowrap"
                  onClick={(e) => e.stopPropagation()}
                >
                  {categoryName}
                </Link>
                <span className="text-xs text-foreground-400">{publishDate}</span>
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                {title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                {excerpt}
              </p>
            </div>
            <div className="flex items-center gap-4 mt-3 text-xs text-foreground-400">
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {viewCount >= 10000 ? `${(viewCount / 10000).toFixed(1)}万` : viewCount}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-chat-3-line"></i>
                {commentCount}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}